import React from 'react';
import { Grid, Header3Text, ModalWindow, SmallBodyText } from 'ui-toolkit';
import { SpruceHelpInlineLink } from 'ui-toolkit';
import { useSelector } from 'react-redux';
import { RootStore } from '../../../store/types';
import { useAppDispatch } from '../../../store/store';
import { partiesActionsSlice } from '../../../store/order/orderData/partiesActionsSlice';
import { useSelectCurrentOrder } from 'selectors/order/selectCurrentOrder';
import { loadOrderAsyncAction } from 'store/order/batchedDispatches';
import SwitchDialogWindows from '../../../components/shared/SwitchDialogWindows';
import { IUploadDocument } from '../../../types/order/documents/upload/interfaces';
import styled from 'styled-components';
import {
  IDocumentInformation,
  UploadDocumentContainer,
} from '../../../components/order/documentsPortal/standardDocuments/uploadDocuments/UploadDocumentContainer';
import { IDocumentCategory } from 'types/order/documents/IDocumentCategoryType';
import { PineconeThemeProvider } from '../../../ui-toolkit/theming/PineconeThemeProvider';

interface IAddDocumentModalProps {
  onUploadDocuments: (documents: IUploadDocument[]) => Promise<any>;
  onClose: () => void;
  onDrop: (files: File[]) => void;
  orderId: string;
  uploadedDocuments: IDocumentInformation[];
  setUploadedDocuments: (value: IDocumentInformation[]) => void;
  categories: IDocumentCategory[];
}

const StyledSmallBodyText = styled(SmallBodyText)`
  margin-bottom: 10px;
  align-self: flex-start;
`;

export const AddDocumentModal: React.FC<IAddDocumentModalProps> = ({
  onClose,
  onDrop,
  onUploadDocuments,
  orderId,
  uploadedDocuments,
  setUploadedDocuments,
  categories,
}) => {
  const { data: orderData } = useSelectCurrentOrder();
  const partyAction = useSelector((state: RootStore) => state.order.partiesActionsSlice);
  const dispatch = useAppDispatch();
  const successMessage = (
    <Grid textAlign={'center'}>
      <Header3Text>Document has been added!</Header3Text>
    </Grid>
  );

  const onCloseClick = () => {
    dispatch(partiesActionsSlice.actions.reset({}));
    dispatch(loadOrderAsyncAction(orderData.transaction.id!));
    onClose();
  };

  return (
    <PineconeThemeProvider>
      <SwitchDialogWindows
        updating={partyAction.fetchStatus.fetching}
        processingTitle={'Working...'}
        updated={partyAction.fetchStatus.fetched}
        error={partyAction.fetchError && partyAction.fetchError.message}
        successTitle={''}
        successMessage={successMessage}
        errorTitle={
          <Header3Text>
            Document was not added. Please <SpruceHelpInlineLink /> to submit a request for help.
          </Header3Text>
        }
        onCancelClick={onCloseClick}
        defaultDialogComponent={
          <ModalWindow uitype={'fit'} title={'Add document(s)'} onClose={onCloseClick}>
            <StyledSmallBodyText>Add one or more documents for upload.</StyledSmallBodyText>
            <UploadDocumentContainer
              onUploadDocuments={onUploadDocuments}
              onClose={onClose}
              onDrop={onDrop}
              orderId={orderId}
              setUploadedDocuments={setUploadedDocuments}
              uploadedDocuments={uploadedDocuments}
              categories={categories}
            />
          </ModalWindow>
        }
      />
    </PineconeThemeProvider>
  );
};
